/* eslint-disable react/jsx-props-no-spreading */
import { useTranslation } from 'react-i18next';
import CustomModalHeader from 'components/modal/customModalHeader';
import {HiOutlineCalendar, HiOutlineX} from 'react-icons/hi';
import useUser from 'hooks/useUser';
import { Modal } from 'flowbite-react';
import  { useEffect, useRef, useState } from 'react';
import { themModal } from 'utils/theme';
import '../../form/styles.scss';
import GroupButton from 'components/button/groupButton';
import { exportReconcillationReport } from 'api/stockApi';
import { useSelector } from 'react-redux';
import { locationSelector, orgSelector, userSelector } from 'redux/selectors';
import MultiSelect from 'components/select/index';
import { pageType, permissionKeys, sortByTypeType, defaultpageCount } from 'utils/constants';
import { checkOrgAdmin, checkPermission, getUserOrg } from 'utils/utils';
import { getLocationByFilter } from 'api/locationApi';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css'; // Import a Flatpickr theme
import { toast } from 'react-toastify';

type exportReconciliationModalProps = {
  openModal: boolean,
  setOpenModal: Function,
  headerTitle?: string
};
const ExportReconciliationReportModal = (props: exportReconciliationModalProps) => {
  const { openModal, setOpenModal, headerTitle } = props;
  const { fetchCurrentUser } = useUser();
  const [t] = useTranslation();
  const { userInfo } = useSelector(userSelector);
  const rootRef = useRef(null);
  const { organizationId } = useSelector(orgSelector);
  const { locationId } = useSelector(locationSelector);
  const [selectedType, setSelectedType] = useState<any>({label: 'This Location', value: "This"});
  const [typeOptions, setTypeOptions] = useState([
            {label: 'This Location', value: "This"},
            {label: 'All My Locations', value: "All"}
        ]);
  const {WRITE_LOCATION, PLATFORM_ADMIN} = permissionKeys;
  const isAdmin = checkPermission(userInfo, pageType.LOCATION, [PLATFORM_ADMIN], organizationId);
  const isOrgAdmin = checkOrgAdmin(userInfo, organizationId, isAdmin);
  const flatpickrRef = useRef<Flatpickr | null>(null);
  const [dateFilter, setDateFilter] = useState<any>([]);
  const [fDate, setFDate] = useState('');
  const [tDate, setTDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const pageCountDefault = 1000;
  const [errors, setErrors] = useState<any>({
    date: t('requiredField'),
    location: ''
  });
      
    
  const getRegions = () => {
        const userOrg = userInfo?.organizations?.find((o: any) => o.id === organizationId);
        const orgRegions = userOrg?.regions;
        let regionIds = '';
        if (orgRegions) {
            for (let index = 0; index < orgRegions.length; index++) {
                const region = orgRegions[index];
                if (regionIds === '') {
                    regionIds = region.id;
                } else {
                    regionIds = `${regionIds},${region.id}`;
                }
            }
        }
        return regionIds;
    }

    const handleChangeDate = (option: any) => {
      let err = errors;
      if (option) {
        err.date = '';
        setErrors(err);
        if (option[1]) {
          setFDate((option[0] as Date).toLocaleDateString());
          setTDate((option[1] as Date).toLocaleDateString());
          setDateFilter(option);
      }
      } else {
          err.date = t('requiredField');
          setErrors(err);
          setFDate('');
          setTDate('');
          setDateFilter([]);
      }
    };
    
    const handleClearSelection = () => {
      let err = errors;
      if (flatpickrRef.current) {
          flatpickrRef.current.flatpickr.clear();
          setFDate('');
          setTDate('');
          err.date = t('requiredField');
          setErrors(err);
      }
    };

  const toggleHandler = () => {
    setOpenModal(!openModal);
  };

  const handleExportItem = async () => {
    if (errors.date !== '' || errors.location !== '') {
      toast.error(`${t('uploadFile.exportError')}`);
      return;
    }

    setSelectedType(selectedType);
    setIsLoading(true);
    if (selectedType?.value === "This") {
        exportReconcillationReport(organizationId, { locationId, fDate, tDate }).then(res => {
          if (res.data || res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `reconcillation-report.csv`);
            document.body.appendChild(link)
            link.click();
    
            // Remove dom after finish
            document.body.removeChild(link);
            setIsLoading(false);
          }
          else {
            toast.error(`${t('uploadFile.exportError')}`);
            setIsLoading(false);
          }
        })
        .catch(err => {
          toast.error(`${t('uploadFile.exportError')}`);
          setIsLoading(false);
        });
    } else {
      let ids = '';
      const resCount = await getLocationByFilter({ page: 0, limit: 5, sortByType: sortByTypeType.DESC, organizationId, userOrgId: isOrgAdmin === true ? null : getUserOrg(userInfo, organizationId)?.userOrganizationId, regionIds: isOrgAdmin === true ? '' : getRegions(), isActive: true });
      const totalCount  = resCount?.data?.totalEntities;
      const pageBreak = Math.ceil(totalCount / pageCountDefault);
      let listTemps: any = [];
      for (let index = 0; index < pageBreak; index++) {
        const resPage = await getLocationByFilter({ page: index, limit: pageCountDefault, sortByType: sortByTypeType.DESC, organizationId, userOrgId: isOrgAdmin === true ? null : getUserOrg(userInfo, organizationId)?.userOrganizationId, regionIds: isOrgAdmin === true ? '' : getRegions(), isActive: true });
        if (listTemps.length === 0) {
          listTemps = resPage?.data?.entities;
        } else {
          listTemps = listTemps.concat(resPage?.data?.entities);
        }
      }
      if (listTemps) {
        for (let index = 0; index < listTemps?.length; index++) {
          const element = listTemps[index];
            if (ids === '') {
              ids = element.id;
            } else {
              ids = `${ids},${element.id}`;
            }
        }
      }
      exportReconcillationReport(organizationId, { locationIds: ids, fDate, tDate }).then(res => {
        if (res.data || res.status === 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `reconcilation-report.csv`);
          document.body.appendChild(link)
          link.click();
            
          // Remove dom after finish
          document.body.removeChild(link);
          setIsLoading(false);
          }
          else {
            toast.error(`${t('uploadFile.exportError')}`);
            setIsLoading(false);
          }
      })
      .catch(err => {
        toast.error(`${t('uploadFile.exportError')}`);
        setIsLoading(false);
      });
    }
  };

  const handleChangeType = (option: any) => {
    setSelectedType(option);
    let err = errors;
    if (!option) {
      err.location = t('requiredField');
      setErrors(err);
    }
    else {
      err.location = '';
      setErrors(err);
    }
};

  return (
    <div ref={rootRef} className="group-modal-container">
      <Modal
        show={openModal}
        size="2xl"
        className="group-modal"
        root={rootRef.current ?? undefined}
        onClose={toggleHandler}
        //dismissible={true}
        theme={themModal}
      >
        <CustomModalHeader title={headerTitle} toggle={toggleHandler} />
        <Modal.Body theme={{ base: 'flex-12 pb-4 pt-3 px-12' }}>
          <div className="custom-date-range-modal date-range48 mt-4 relative">
                            <Flatpickr
                                ref={flatpickrRef}
                                value={dateFilter}
                                onChange={(e: any) => handleChangeDate(e)}
                                options={
                                    {
                                        mode: 'range',
                                        dateFormat: 'M-d-Y'
                                    }
                                }
                                placeholder="Select Date"
                            />
                            {fDate !== '' && tDate !== '' ?
                                <button onClick={handleClearSelection}><HiOutlineX/></button> : <HiOutlineCalendar/>}
              </div>
              {errors?.date !== '' && <div className={`text-red-600 text-xs font-normal mt-1 veri-modal height-16`}>{errors?.date}</div>}
            <div className="mt-4 relative flex md:flex-row flex-col">
                <MultiSelect
                        onChange={handleChangeType}
                        options={typeOptions}
                        value={selectedType}
                        name="type"
                        noOptionsMessage={() => t('No options')}
                        closeMenuOnSelect
                        isHolderLabel={true}
                        placeholder={`${t('orderPage.location')}`}
                    />
            </div>
            {errors?.location !== '' && <div className={`text-red-600 text-xs font-normal mt-1 veri-modal height-16`}>{errors?.location}</div>}
            <GroupButton
              className="items-center justify-center pt-5 mb-4"
              buttons={[
                {
                  type: 'button',
                  text: t('modal.cancel'),
                  classType: 'white',
                  action: () => toggleHandler(),
                },
                {
                  type: 'button',
                  text: t('modal.export'),
                  classType: 'blue',
                  isLoading: isLoading,
                  action: () => handleExportItem(),
                },
              ]}
            />
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default ExportReconciliationReportModal;
